var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 8a.9.9 0 10-1.8 0v4.5c0 .38.23.71.58.84l4 1.5a.9.9 0 00.64-1.68l-3.42-1.28V8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1a9.9 9.9 0 100 19.8 9.9 9.9 0 000-19.8zM3.9 12a8.1 8.1 0 1116.2 0 8.1 8.1 0 01-16.2 0z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLjQgOGEuOS45IDAgMSAwLTEuOCAwdjQuNWMwIC4zOC4yMy43MS41OC44NGw0IDEuNWEuOS45IDAgMCAwIC42NC0xLjY4bC0zLjQyLTEuMjhWOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMi4xYTkuOSA5LjkgMCAxIDAgMCAxOS44IDkuOSA5LjkgMCAwIDAgMC0xOS44Wk0zLjkgMTJhOC4xIDguMSAwIDEgMSAxNi4yIDAgOC4xIDguMSAwIDAgMS0xNi4yIDBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";
export { SvgClockOutline24 as ReactComponent };